var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02511 0C14.0096 0 18.0499 4.01283 18.0499 8.96257C18.0499 13.9123 14.0093 17.9248 9.02511 17.9248C4.04097 17.9248 0 13.9123 0 8.96257C0 4.01283 4.04067 0 9.02511 0ZM23.4376 0.525004C25.9298 0.525004 27.9501 4.30225 27.9501 8.96257H27.9504C27.9504 13.6217 25.9301 17.4001 23.4379 17.4001C20.9457 17.4001 18.9253 13.6217 18.9253 8.96257C18.9253 4.30346 20.9454 0.525004 23.4376 0.525004ZM30.4129 1.40384C31.2892 1.40384 32 4.78794 32 8.96257C32 13.136 31.2896 16.5213 30.4129 16.5213C29.5363 16.5213 28.8262 13.1369 28.8262 8.96257C28.8262 4.78824 29.5366 1.40384 30.4129 1.40384Z",
    fill: "#3C1A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.3f72962d898ea2837e6967cdab280632.svg";
export { ForwardRef as ReactComponent };